import { Helmet } from 'react-helmet-async';

const SEO_DEFAULTS = {
  siteName: 'DoktorCebinde',
  defaultTitle: 'DoktorCebinde | Kişisel Sağlık Takip ve AI Destek Platformu',
  defaultDescription: 'Kendi sağlığınızı takip edin. Hafıza, uyku, kaygı ve kalp sağlığı için AI destekli analizler ve günlük sağlık takibi.',
};

const PageSEO = ({ title, description }) => {
  const fullTitle = title ? `${title} | ${SEO_DEFAULTS.siteName}` : SEO_DEFAULTS.defaultTitle;
  const desc = description || SEO_DEFAULTS.defaultDescription;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
    </Helmet>
  );
};

export default PageSEO;
